import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
    selector: 'app-unauthorized',
    standalone: true,
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ MatCard, MatDialogModule ]
})
export class UnauthorizedComponent {

  constructor() { }
}
